import { Modal } from '@perch-labs/shrike';
import styled from 'styled-components';
import { Text } from '~/components/typography';

export const StyledSection = styled.section`
  padding: 32px;

  :not(:first-of-type) {
    padding-top: 0px;
  }

  li {
    margin-left: 16px;
  }
`;

export const StyledText = styled(Text)`
  margin-bottom: 16px;

  :last-of-type {
    margin-bottom: 0px;
  }
`;

export const StyledModal = styled(Modal)`
  [data-reach-dialog-content] {
    padding: 0px;
    margin: 0 auto;
  }
`;
